import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DownloadMissingTranslationComponent } from './download-missing-translation.component';
import { MatButtonModule } from '@angular/material';

@NgModule({
  declarations: [DownloadMissingTranslationComponent],
  imports: [
    CommonModule,
    MatButtonModule
  ]
})
export class DownloadMissingTranslationComponentModule { }
